var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90321 10.2955C5.75181 11.9105 5.64556 14.7686 6.59915 15.9852C6.59915 15.9852 6.15024 12.8455 10.1745 8.90625C11.7948 7.32047 12.1693 5.1636 11.6035 3.54594C11.2821 2.62953 10.6951 1.8725 10.1851 1.34391C9.88759 1.03313 10.116 0.520473 10.549 0.539066C13.1681 0.655941 17.4127 1.38375 19.2163 5.91C20.0079 7.89688 20.0663 9.95016 19.6891 12.038C19.4501 13.3714 18.6001 16.3358 20.5392 16.6997C21.9231 16.96 22.5924 15.8603 22.8926 15.0688C23.0174 14.7394 23.4504 14.657 23.6841 14.92C26.0216 17.5789 26.2209 20.7106 25.7374 23.4067C24.8024 28.6183 19.5245 32.4114 14.281 32.4114C7.73071 32.4114 2.51649 28.6634 1.16446 21.8794C0.619931 19.1408 0.896181 13.722 5.11962 9.89703C5.43306 9.61016 5.94571 9.86516 5.90321 10.2955Z",
    fill: "url(#paint0_radial_544_3178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6739 20.0413C14.2594 16.9335 15.3405 13.3874 15.9328 11.9743C16.0125 11.7883 15.8 11.613 15.6327 11.7272C14.5941 12.4338 12.4664 14.0966 11.4757 16.4368C10.1342 19.6004 10.2299 21.149 11.0241 23.0402C11.5022 24.1797 10.9471 24.4215 10.6682 24.464C10.3972 24.5065 10.1475 24.3258 9.94831 24.1372C9.37519 23.587 8.96678 22.8879 8.76893 22.1185C8.72643 21.9538 8.51128 21.9086 8.41299 22.0441C7.66924 23.0721 7.28409 24.7216 7.26549 25.8877C7.20706 29.4922 10.1847 32.4141 13.7866 32.4141C18.3261 32.4141 21.6332 27.3938 19.0247 23.1969C18.2677 21.975 17.5558 21.1755 16.6739 20.0413Z",
    fill: "url(#paint1_radial_544_3178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_544_3178",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9837 32.494) rotate(-179.751) scale(18.7498 30.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_544_3178",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0363 13.8359) rotate(90.5787) scale(19.6181 14.7641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF8BD",
    stopOpacity: 0.804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF6AB",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF38D",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF176",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.f60a3c19e98215482eaa59718483aa4e.svg";
export { ForwardRef as ReactComponent };